import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';

const FormGuide = ({ form, size = 'normal', className = '' }) => {
  if (!form || form.length === 0) {
    return null;
  }

  const getFormColor = (percentage) => {
    if (percentage >= 80) return 'text-green-600 bg-green-50 border-green-200';
    if (percentage >= 60) return 'text-blue-600 bg-blue-50 border-blue-200';
    if (percentage >= 40) return 'text-yellow-600 bg-yellow-50 border-yellow-200';
    return 'text-red-600 bg-red-50 border-red-200';
  };

  const iconSize = size === 'small' ? 'w-3 h-3' : 'w-4 h-4';
  const textSize = size === 'small' ? 'text-xs' : 'text-sm';
  const padding = size === 'small' ? 'p-1' : 'p-2';

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {form.map((match, idx) => (
        <div
          key={idx}
          className={`${padding} rounded border ${
            match.result === 'W'
              ? 'bg-green-50 border-green-300'
              : 'bg-red-50 border-red-300'
          }`}
          title={match.match_date}
        >
          {match.result === 'W' ? (
            <CheckCircle className={`${iconSize} text-green-600`} />
          ) : (
            <XCircle className={`${iconSize} text-red-600`} />
          )}
        </div>
      ))}
    </div>
  );
};

export default FormGuide;
